// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1200":"communications","3067":"awr","3899":"explore-learning","4984":"become-stories","6200":"become","9636":"landing"}[chunkId] + "." + {"1200":"5b22c962","3067":"5b22c962","3899":"25a936ab","4984":"5b22c962","6200":"5b22c962","9636":"5b22c962"}[chunkId] + ".chunk.css";
};